import { PortalDropdown } from '@/components/ui/PortalDropdown'
import { FaBookmark } from 'react-icons/fa'
import { FiBookmark, FiEdit2, FiTrash2 } from 'react-icons/fi'

type ThreadDropdownMenuProps = {
  isOpen: boolean
  position: { top: number; left: number }
  isBookmarked: boolean
  onToggleFavorite: () => void
  onRename: () => void
  onDelete: () => void
  menuRef: React.RefObject<HTMLDivElement | null>
}

export function ThreadDropdownMenu({
  isOpen,
  position,
  isBookmarked,
  onToggleFavorite,
  onRename,
  onDelete,
  menuRef,
}: ThreadDropdownMenuProps) {
  return (
    <PortalDropdown isOpen={isOpen} position={position} dropdownRef={menuRef}>
      <div className="font-hanken-grotesk w-40 rounded-lg border border-gray-200 bg-white py-1.5 shadow-lg">
        <button
          onClick={(e) => {
            e.preventDefault()
            onToggleFavorite()
          }}
          className="text-ui-text hover:bg-ui-hover flex w-full items-center gap-3 px-3 py-1.5 text-sm font-normal transition-colors"
        >
          {isBookmarked ? (
            <FaBookmark className="h-4 w-4 text-blue-600" />
          ) : (
            <FiBookmark className="text-ui-secondary h-4 w-4" />
          )}
          {isBookmarked ? 'Unbookmark' : 'Bookmark'}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault()
            onRename()
          }}
          className="text-ui-text hover:bg-ui-hover flex w-full items-center gap-3 px-3 py-1.5 text-sm font-normal transition-colors"
        >
          <FiEdit2 className="text-ui-secondary h-4 w-4" />
          Rename
        </button>
        <button
          onClick={(e) => {
            e.preventDefault()
            onDelete()
          }}
          className="hover:bg-ui-hover flex w-full items-center gap-3 px-3 py-1.5 text-sm font-normal text-red-600 transition-colors"
        >
          <FiTrash2 className="h-4 w-4" />
          Delete
        </button>
      </div>
    </PortalDropdown>
  )
}
